import PropTypes from 'prop-types';
import React from 'react';

import ContentGridItem from '@glass/shared/components/Content/ContentGridItem';
import ContentTypography from '@glass/shared/components/Content/ContentTypography';
import IndustryLink from '@glass/shared/components/Link/IndustryLink';
import industryPropTypes from '@glass/shared/modules/jobTitles/industryPropTypes';

function IndustryGridItemLink({ name, slug, width, loading, onClick }) {
  return (
    <ContentGridItem>
      <ContentTypography
        component={IndustryLink}
        industrySlug={slug}
        loading={loading}
        name={name}
        prefetch={false}
        width={width}
        onClick={onClick}
      />
    </ContentGridItem>
  );
}

IndustryGridItemLink.propTypes = {
  ...industryPropTypes,
  loading: PropTypes.bool,
  onClick: PropTypes.func,
  width: PropTypes.string,
};

export default React.memo(IndustryGridItemLink);
